import { rem } from 'polished';
import styled from 'styled-components';
import { getMaxPageWidth } from '../../constants';
import { breakpoints } from '../../styles/theme';

export const Table = styled.div`
    margin: 0 ${rem(15)};
`;

export const TableHeader = styled.div`
    border-bottom: 2px solid ${({ theme }) => theme.colors.secondaryGrey};
    padding: ${rem(20)} 0;
`;

export const TableHeaderLabel = styled.span<{ width: number; center?: boolean; hideOnMobile?: boolean }>`
    ${(prop) => (prop.width ? `width: ${prop.width}%;` : '')};
    ${(prop) => (prop.center ? `text-align: center;` : '')};
    ${(prop) => (prop.hideOnMobile ? `display: none;` : '')};
    font-size: ${({ theme }) => theme.fontSizes.textBase};

    @media (min-width: ${breakpoints.sm}px) {
        display: inline-block;
    }
`;

export const TableItem = styled.div<{ isCheckout?: boolean; isSummary?: boolean; hasTags?: boolean }>`
    padding: ${rem(25)} 0;
    border-bottom: ${(props) => (props.hasTags ? 'none' : `1px solid ${props.theme.colors.secondaryGrey}`)};

    @media (min-width: ${breakpoints.sm}px) {
        display: flex;
        align-items: center;
        padding: ${rem(25)} 0;
    }
`;

export const Tags = styled.div`
    padding: ${rem(10)};

    @media (min-width: ${breakpoints.sm}px) {
        padding: ${rem(10)} 0 ${rem(25)} 0;
    }

    border-bottom: 1px solid ${({ theme }) => theme.colors.secondaryGrey};
`;

export const ProductDetail = styled.div`
    @media (min-width: ${breakpoints.sm}px) {
        width: 30%;
    }
`;

export const ProductName = styled.span<{ isBold?: boolean; noWrap?: boolean }>`
    font-weight: ${(props) => (props.isBold ? props.theme.fontWeights.textBold : props.theme.fontWeights.textLight)};
    display: block;
    cursor: pointer;

    ${(prop) => (prop.isBold ? `font-weight: ${prop.theme.fontWeights.textBold}` : '')};
    ${(prop) => (prop.noWrap ? `white-space: nowrap` : '')};
`;

export const Form = styled.span<{ withMarginTop?: boolean }>`
    display: inline-block;
    margin-top: ${(props) => (props.withMarginTop ? rem(5) : 0)};
`;

export const HasBoughtTag = styled.span`
    display: block;
    background: ${({ theme }) => theme.colors.green};
    color: ${({ theme }) => theme.colors.white};
    font-size: ${({ theme }) => theme.fontSizes.textSmall};
    padding: ${rem(4)} 0;
    font-weight: 400;
    margin-bottom: ${rem(8)};
    width: ${rem(95)};
    text-transform: uppercase;
    text-align: center;
    border-radius: ${rem(16)};
`;

export const ProductDate = styled.span`
    display: block;
    padding-top: ${rem(5)};
    color: ${({ theme }) => theme.colors.grey};
`;

export const ProductMap = styled.a`
    color: ${({ theme }) => theme.colors.primary};
    cursor: pointer;
    text-decoration: unset;
`;

export const ProductQuantity = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${rem(10)} 0 ${rem(15)} 0;

    @media (min-width: ${breakpoints.sm}px) {
        width: 20%;
        justify-content: center;
        margin-left: ${rem(5)};
        padding: 0;
    }
`;

export const ProductPrice = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (min-width: ${breakpoints.sm}px) {
        width: 20%;
        justify-content: center;
        height: ${rem(40)};
    }
`;

export const Buy = styled.div`
    display: flex;
    align-items: center;
    margin-right: 0;
    padding: ${rem(25)} 0 0 0;
    cursor: pointer;
    margin-left: 50%;

    @media (min-width: ${breakpoints.sm}px) {
        padding: 0;
        width: 20%;
        margin-left: 5%;
    }
`;

export const Label = styled.span`
    color: ${({ theme }) => theme.colors.grey};

    @media (min-width: ${breakpoints.sm}px) {
        display: none;
    }
`;

export const ProductPackage = styled.span`
    display: inline-block;
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    margin-bottom: ${rem(10)};
    padding-left: ${rem(10)};
`;

export const ProductPackageTitle = styled.span<{ minWidth?: number }>`
    color: ${({ theme }) => theme.colors.grey};
    display: block;
    ${(prop) => (prop.minWidth ? `min-width: ${prop.minWidth}px;` : '')};
`;

export const Value = styled.span<{ isPrice?: boolean; withHeight?: boolean }>`
    text-align: center;
    display: flex;
    align-items: center;
    font-weight: ${({ theme }) => theme.fontWeights.textBold};
    ${(prop) => (prop.isPrice ? `font-size: ${prop.theme.fontSizes.textMedium};` : '')};
    ${(prop) => (prop.withHeight ? `height: ${rem(40)};` : '')};
`;

export const Item = styled.div``;
